import {
    IS_LOADING,
    SET_CURRENT_FORM,
    SET_FORMS_FILTERS,
    SET_INTERVIEWS,
    SET_INTERVIEWS_TO_MANAGE,
    SET_FORM_SECTIONS,
    SET_CURRENT_SECTION,
    SET_FORM_SURVEYS,
    SET_EMPLOYEES_TO_MANAGE,
    SET_CURRENT_INTERVIEW,
    SET_PERIODS,
    SET_MANAGERS,
    SET_EMPLOYEES_OF_COMPANY,
    SET_INTERVIEWS_FOR_HR,
    SET_HR_TAB_ID,
    FORMS_TO_MANAGE,
    HUMAN_RESOURCES,
    MY_FORMS,
    SET_DEPARTMENTS_OF_COMPANY,
    SET_NB_WAITING_INTERVIEWS,
    SET_COMPANIES_WITH_EVALUATIONS
} from "./humanResourcesConstants";
import { throwErrorMessage } from "../../lib/error_helper";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import {
    adaptElementInspectionForMyOpen,
    adaptFormSectionForMyOpen,
} from "./humanResourcesCast";
import { ALL_SELECT_OPTION } from "../../constants";
import { clone, deepCompare, downloadFile } from "../../utils";

export function formsIsLoading(value, loadingType) {
    return {
        type: IS_LOADING,
        info: "humanResourcesForms-" + loadingType,
        isLoading: value,
    };
}

export function humanResourcesIsLoading(value) {
    return {
        type: IS_LOADING,
        info: "humanResources",
        isLoading: value,
    };
}

export function nbWaitingInterviewsIsLoading(value) {
    return {
        type: IS_LOADING,
        info: 'Récupération du nombre d\'entretien en cours',
        isLoading: value
    };
}

export function setInterviewsAction(interviews) {
    return {
        type: SET_INTERVIEWS,
        interviews: interviews,
    };
}

export function setHRTabIdAction(tabId) {
    return {
        type: SET_HR_TAB_ID,
        tabId,
    };
}

export function setFormSurveysAction(formSurveys, filtersInstance) {
    return {
        type: SET_FORM_SURVEYS,
        formSurveys,
        filtersInstance
    }
}

export function setPeriodsAction(periods, filtersInstance) {
    return {
        type: SET_PERIODS,
        periods,
        filtersInstance
    }
}

export function setFormSectionsAction(formSections) {
    return {
        type: SET_FORM_SECTIONS,
        formSections,
    }
}

export function setCurrentSectionAction(currentSectionId) {
    return {
        type: SET_CURRENT_SECTION,
        currentSectionId: currentSectionId,
    }
}

export function setInterviewsToManageAction(interviews) {
    return {
        type: SET_INTERVIEWS_TO_MANAGE,
        interviews: interviews,
    };
}

export function setInterviewsForHRAction(interviews) {
    return {
        type: SET_INTERVIEWS_FOR_HR,
        interviewsForHR: interviews,
    }
}

export function setCurrentFormAction(form) {
    return {
        type: SET_CURRENT_FORM,
        currentForm: form,
    };
}

export function setCurrentInterviewAction(interview) {
    return {
        type: SET_CURRENT_INTERVIEW,
        interview,
    }
}

export function setFormFiltersAction(filters, filtersInstance) {
    return {
        type: SET_FORMS_FILTERS,
        filters: filters,
        filtersInstance,
    };
}

export function setEmployeesToManageAction(employeesToManage) {
    return {
        type: SET_EMPLOYEES_TO_MANAGE,
        employeesToManage
    }
}

export function setEmployeesOfCompanyAction(employeesOfCompany) {
    return {
        type: SET_EMPLOYEES_OF_COMPANY,
        employeesOfCompany
    }
}

export function setDepartmentsOfCompanyAction(departmentsOfCompany) {
    return {
        type: SET_DEPARTMENTS_OF_COMPANY,
        departmentsOfCompany
    }
}

export function setManagersAction(managers, filtersInstance) {
    return {
        type: SET_MANAGERS,
        managers,
        filtersInstance
    }
}

function setNbWaitingInterviewsAction(nb) {
    return {
        type: SET_NB_WAITING_INTERVIEWS,
        nbWaitingInterviews: nb,
    }
}

function setCompaniesWithEvaluations(companies) {
    return {
        type: SET_COMPANIES_WITH_EVALUATIONS,
        companiesWithEvaluations: companies,
    }
}

export function getEmployeesToManage(user) {
    return (dispatch) => {

        const headers = new Headers({ "Content-Type": "application/json" });

        dispatch(humanResourcesIsLoading(true));

        fetchWithTimeout("/api/v1/human_resources/get_employees_to_manage/", {
            method: "POST",
            headers: headers,
            timeout: 60000,
            body: JSON.stringify({
                userId: user.id,
                empId: user.emp_id
            }),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((employees) => {
                dispatch(setEmployeesToManageAction(employees))
                dispatch(humanResourcesIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : humanResourcesActions - getEmployeesToManage", err);

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des collaborateurs !",
                    })
                );

                dispatch(humanResourcesIsLoading(false));
            });
    }
}

export function setHRTabId(tabId) {
    return (dispatch) => {
        dispatch(setHRTabIdAction(tabId));
    }
}

export function generateAndLoadForm(interview, user, onSuccess) {
    return (dispatch) => {

        if (!interview.response) {
            dispatch(generateSurveyResponses(interview, user, onSuccess))
        } else {
            dispatch(loadForm(interview, user))
            onSuccess()
        }
    };
}

export function loadForm(interview) {
    return (dispatch) => {
        dispatch(setCurrentInterviewAction(interview));
        let formSections = interview.response.survey.pages.map(fs => adaptFormSectionForMyOpen(fs))
        dispatch(setFormSectionsAction(formSections))
        dispatch(setCurrentFormAction(interview.response));
        dispatch(setCurrentSectionAction(null));
    }
}

export function generateSurveyResponses(interview, user, onSuccess, reinitDefaultValues=false) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });

        dispatch(formsIsLoading(true, "generateSurveyResponses"));
        fetchWithTimeout("/api/v1/human_resources/generate_survey_responses/", {
            method: "POST",
            headers: headers,
            timeout: 60000,
            body: JSON.stringify({
                user: user,
                interviewId: interview.id,
                reinitDefaultValues: reinitDefaultValues
            }),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(async (interview) => {
                dispatch(loadForm(await adaptElementInspectionForMyOpen(interview)));
                if (onSuccess && typeof onSuccess === "function")
                    onSuccess()

                dispatch(formsIsLoading(false, "generateSurveyResponses"));
            })
            .catch((err) => {
                console.error(
                    "Erreur : humanResourcesActions - generate_survey_responses",
                    err
                );

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la génération des réponses de l'entretien !",
                    })
                );

                dispatch(formsIsLoading(false, "generateSurveyResponses"));
            });
    }
}

export function getInterview(id, user) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });
        let filters = {
            interviewId: id
        }

        dispatch(formsIsLoading(true, "getInterview"));
        fetchWithTimeout("/api/v1/human_resources/get_interviews/", {
            method: "POST",
            headers: headers,
            timeout: 60000,
            body: JSON.stringify({
                user: user,
                formsFilters: filters,
            }),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(async (interviews) => {
                if (interviews.length !== 1) {
                    dispatch(
                        throwErrorMessage({
                            errorObject: interviews,
                            title: "Erreur",
                            message: "Erreur lors de la récupération de l'évaluation !",
                        })
                    );

                    dispatch(formsIsLoading(false, "getInterview"));
                    return;
                }

                let interview = await adaptElementInspectionForMyOpen(interviews[0]);
                dispatch(loadForm(interview));
                dispatch(formsIsLoading(false, "getInterview"));
            })
            .catch((err) => {
                console.error(
                    "Erreur : humanResourcesActions - getInterview",
                    err
                );

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération de l'évaluation !",
                    })
                );

                dispatch(formsIsLoading(false, "getInterview"));
            });
    };
}

export function getMyFormsAndInterviews(user, formsFilters) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });
        let filters = clone(formsFilters)
        filters.employee = filters.employee === ALL_SELECT_OPTION ? null : filters.employee
        filters.manager = filters.manager === ALL_SELECT_OPTION ? null : filters.manager
        filters.survey = filters.survey === ALL_SELECT_OPTION ? null : filters.survey
        filters.period = filters.period === ALL_SELECT_OPTION ? null : filters.period
        filters.companies = [];

        dispatch(formsIsLoading(true, "getMyFormsAndInterviews"));
        fetchWithTimeout("/api/v1/human_resources/get_interviews/", {
            method: "POST",
            headers: headers,
            timeout: 60000,
            body: JSON.stringify({
                user: user,
                formsFilters: filters,
                myInterviews: true
            }),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(async (interviews) => {
                interviews = await Promise.all(interviews.map(async e => await adaptElementInspectionForMyOpen(e)));
                dispatch(setInterviewsAction(interviews))
                dispatch(formsIsLoading(false, "getMyFormsAndInterviews"));
            })
            .catch((err) => {
                console.error(
                    "Erreur : humanResourcesActions - getMyFormsAndInterviews",
                    err
                );

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des évaluations !",
                    })
                );

                dispatch(formsIsLoading(false, "getMyFormsAndInterviews"));
            });
    };
}

export function getFormsAndInterviewsToManage(user, formsFilters) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });

        let filters = clone(formsFilters)
        filters.employee = filters.employee === ALL_SELECT_OPTION ? null : filters.employee
        filters.manager = filters.manager === ALL_SELECT_OPTION ? null : filters.manager
        filters.survey = filters.survey === ALL_SELECT_OPTION ? null : filters.survey
        filters.period = filters.period === ALL_SELECT_OPTION ? null : filters.period
        filters.level = filters.level === ALL_SELECT_OPTION ? null : filters.level
        filters.companies = [];

        dispatch(formsIsLoading(true, "getFormsAndInterviewsToManage"));
        fetchWithTimeout("/api/v1/human_resources/get_interviews/", {
            method: "POST",
            headers: headers,
            timeout: 60000,
            body: JSON.stringify({
                user: user,
                formsFilters: filters,
                interviewsToManage: true
            }),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(async (interviews) => {
                interviews = await Promise.all(interviews.map(async i => await adaptElementInspectionForMyOpen(i)))
                dispatch(setInterviewsToManageAction(interviews))
                dispatch(formsIsLoading(false, "getFormsAndInterviewsToManage"));
            })
            .catch((err) => {
                console.error(
                    "Erreur : humanResourcesActions - getFormsAndInterviewsToManage",
                    err
                );

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des entretiens !",
                    })
                );

                dispatch(formsIsLoading(false, "getFormsAndInterviewsToManage"));
            });
    };
}

export function getInterviewsForHR(user, formsFilters) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });
        let filters = clone(formsFilters)
        filters.employee = filters.employee === ALL_SELECT_OPTION ? null : filters.employee
        filters.manager = filters.manager === ALL_SELECT_OPTION ? null : filters.manager
        filters.survey = filters.survey === ALL_SELECT_OPTION ? null : filters.survey
        filters.period = filters.period === ALL_SELECT_OPTION ? null : filters.period

        dispatch(formsIsLoading(true, "getInterviewsForHR"));
        fetchWithTimeout("/api/v1/human_resources/get_interviews/", {
            method: "POST",
            headers: headers,
            timeout: 60000,
            body: JSON.stringify({
                user: user,
                formsFilters: filters,
                allInterviews: true
            }),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(async (interviews) => {
                interviews = await Promise.all(interviews.map(async e => await adaptElementInspectionForMyOpen(e)));
                dispatch(setInterviewsForHRAction(interviews))
                dispatch(formsIsLoading(false, "getInterviewsForHR"));
            })
            .catch((err) => {
                console.error(
                    "Erreur : humanResourcesActions - getMyFormsAndInterviews",
                    err
                );

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des évaluations !",
                    })
                );

                dispatch(formsIsLoading(false, "getInterviewsForHR"));
            });
    };
}

export function sectionHasChanged(sectionA, sectionB) {
    if (sectionA !== sectionB || !deepCompare(sectionA, sectionB)) throw new Error("Les sections sont différentes");

    return false;
}

export function getFilters(user, filters, myInterviews, interviewsToManage, allInterviews) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });
        let filtersInstance = getFiltersInstance(myInterviews, interviewsToManage, allInterviews);

        if(filters)
            dispatch(setFormFiltersAction(filters, filtersInstance));

        dispatch(humanResourcesIsLoading(true));
       
        fetchWithTimeout("/api/v1/human_resources/get_filters/", {
            method: "POST",
            headers: headers,
            timeout: 60000,
            body: JSON.stringify({
                user: user,
                myInterviews,
                interviewsToManage,
                allInterviews,
                companyIds: filters ? filters.companies : null,
                departmentIds: filters ? filters.departments : null
            }),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((filters) => {                
                dispatch(setPeriodsAction(filters.periods, filtersInstance))
                dispatch(setFormSurveysAction(filters.surveys, filtersInstance))
                if (!allInterviews) {
                    dispatch(setManagersAction(filters.managers, filtersInstance))
                }                
                dispatch(humanResourcesIsLoading(false));
            })
            .catch((err) => {
                console.error(
                    "Erreur : humanResourcesActions - getFilters",
                    err
                );

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des filtres !",
                    })
                );

                dispatch(humanResourcesIsLoading(false));
            });
    }
}

export function getDepartmentsByCompany(companyIds, user, onSuccess) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });

        dispatch(humanResourcesIsLoading(true));

        fetchWithTimeout("/api/v1/human_resources/get_departments_by_company/", {
            method: "POST",
            headers: headers,
            timeout: 60000,
            body: JSON.stringify({
                userId: user.id,
                companyIds
            }),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((departments) => {

                dispatch(setDepartmentsOfCompanyAction(departments));
                if (onSuccess && typeof onSuccess === "function")
                    onSuccess(departments);

                if (departments && departments.length > 0) {
                    dispatch(humanResourcesIsLoading(false));
                } else {
                    dispatch(getEmployeesByCompanies(companyIds, user));
                }
            })
            .catch((err) => {
                console.error("Erreur : humanResourcesActions - getDepartmentsByCompany", err);

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des départements !",
                    })
                );

                dispatch(humanResourcesIsLoading(false));
            });
    }
}

export function getEmployeesByCompanies(companyIds, user) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });

        dispatch(humanResourcesIsLoading(true));

        fetchWithTimeout("/api/v1/human_resources/get_employees_by_companies/", {
            method: "POST",
            headers: headers,
            timeout: 60000,
            body: JSON.stringify({
                userId: user.id,
                companyIds
            }),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((employees) => {
                dispatch(setEmployeesOfCompanyAction(employees))
                dispatch(humanResourcesIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : humanResourcesActions - getEmployeesByCompanies", err);

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des collaborateurs !",
                    })
                );

                dispatch(humanResourcesIsLoading(false));
            });
    }
}

export function getEmployeesByDepartment(departmentIds, companyIds, user) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });

        dispatch(humanResourcesIsLoading(true));

        fetchWithTimeout("/api/v1/human_resources/get_employees_by_department/", {
            method: "POST",
            headers: headers,
            timeout: 60000,
            body: JSON.stringify({
                userId: user.id,
                departmentIds,
                companyIds
            }),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((employees) => {
                dispatch(setEmployeesOfCompanyAction(employees))
                dispatch(humanResourcesIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : humanResourcesActions - getEmployeesByDepartment", err);

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des collaborateurs !",
                    })
                );

                dispatch(humanResourcesIsLoading(false));
            });
    }
}

export function downloadInterview(interview, user) {
    return (dispatch) => {

        dispatch(humanResourcesIsLoading(true));
        const headers = new Headers({ "Content-Type": "application/json" });
        fetchWithTimeout("/api/v1/human_resources/download_interview", {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                interviewId: interview.id,
                userId: user.id,
            }),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((file) => {
                var dataURI = "data:application/pdf;base64," + file;
                let fileName = interview.user_to_review_id.name
                fileName = fileName.concat(interview.phase ? "-" + interview.phase.name : "");

                downloadFile(dataURI, fileName);
                dispatch(humanResourcesIsLoading(false));
            })
            .catch((err) => {
                console.error(
                    "Erreur : humanResourcesActions - downloadInterview: " + err.message
                );

                dispatch(
                    throwErrorMessage({
                        title: "Erreur",
                        message:
                            "Une erreur s'est produite lors du téléchargement de l'entretien",
                    })
                );

                dispatch(humanResourcesIsLoading(false));
            });
    };
}

export function changeEvaluator(inteview, user, formsFilters) {
    return (dispatch) => {

        dispatch(humanResourcesIsLoading(true));
        const headers = new Headers({ "Content-Type": "application/json" });
        fetchWithTimeout("/api/v1/human_resources/change_evaluator", {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                evaluationId: inteview.evaluation_id.id,
                userId: user.id
            }),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((res) => {
                // TODO
                dispatch(getFormsAndInterviewsToManage(user, formsFilters));
                dispatch(humanResourcesIsLoading(false));
            })
            .catch((err) => {
                console.error(
                    "Erreur : humanResourcesActions - changeEvaluator: " + err.message
                );

                dispatch(
                    throwErrorMessage({
                        title: "Erreur",
                        message:
                            "Une erreur s'est produite lors du changement d'évaluateur",
                    })
                );

                dispatch(humanResourcesIsLoading(false));
            });
    };
}

export function resetForm(interview, user) {
    return (dispatch) => {

        if (!window.confirm(
            "Attention, les champs avec une valeur par défaut seront réinitialiser. Voulez-vous continuer ?"
        ))
            return;

        dispatch(generateSurveyResponses(interview, user, (() => {}), true));
    }
}

export function getFiltersInstance(myInterviews, interviewsToManage, allInterviews) {
    if (interviewsToManage) {
        return FORMS_TO_MANAGE;
    } else if (allInterviews) {
        return HUMAN_RESOURCES;
    } else if (myInterviews) {
        return MY_FORMS;
    }

    return null;
}

export function sectionRead(section) {
    return section.questions.some(q => q.response_lines.some(rl => rl.state !== 'draft'))
}

export function isVisible(sections, currentMetaQuestion) {
    if (!currentMetaQuestion.is_conditional)
        return true;//La question n'est pas une question conditionnée

    let conditionalQuestion;

    sections.forEach(s => {//On cherche la question "mère"
        if (!conditionalQuestion)
            conditionalQuestion = s.questions.find(q => q.id == currentMetaQuestion.triggering_question_id);
    })

    if (!conditionalQuestion || conditionalQuestion.response_lines.length <= 0)
        return true;//On a pas trouvé la question "mère" ou la question "mère" n'a pas de réponse (Ce qui n'est pas normal)

    let currentResponses = conditionalQuestion.response_lines[0].response_answers;

    if (currentResponses.find(ra => !ra.deleted && ra.answer_id == currentMetaQuestion.triggering_answer_id) && isVisible(sections, conditionalQuestion))
        return true;

    return false;
}

export function actualizeNbWaitingInterviews(user) {
	return (dispatch) => {        
        dispatch(nbWaitingInterviewsIsLoading(true));
		const headers = new Headers({ "Content-Type": "application/json" });
		dispatch(setNbWaitingInterviewsAction(0));

		fetchWithTimeout("/api/v1/human_resources/get_nb_waiting_interviews/", {
			method: "POST",
            headers: headers,
            timeout: 60000,
            body: JSON.stringify({
                user: user
            }),
		})
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);

            return response;
        })
        .then((response) => response.json())
        .then((result) => {
            dispatch(setNbWaitingInterviewsAction(result));
            dispatch(nbWaitingInterviewsIsLoading(false));
        })
        .catch((err) => {
            console.error(
                "Erreur : humanResourcesActions - actualizeNbWaitingInterviews",
                err
            );
            dispatch(nbWaitingInterviewsIsLoading(false));
        });
	};
}

export function getCompaniesWithEvaluations(user) {
	return (dispatch) => {        
        dispatch(humanResourcesIsLoading(true));
		const headers = new Headers({ "Content-Type": "application/json" });

		fetchWithTimeout("/api/v1/human_resources/get_companies_with_evaluations/" + user.id, {
			method: "GET",
			headers: headers,
			timeout: 60000
		})
        .then((response) => {
            if (!response.ok) throw Error(response.statusText);

            return response;
        })
        .then((response) => response.json())
        .then((result) => {
            dispatch(setCompaniesWithEvaluations(result));
        })
        .catch((err) => {
            console.error(
                "Erreur : humanResourcesActions - getCompaniesWithEvaluations",
                err
            );
            dispatch(humanResourcesIsLoading(true));
        });
	};
}
